import React from "react"
import { useTranslation } from "react-i18next"
import { Typography, styled } from "@mui/material"

import Back from "components/ui/Back"

type Props = React.HTMLAttributes<HTMLDivElement> & {
  back?: boolean
}

const TitleComponent = ({ back, ...restProps }: Props) => {
  const { t } = useTranslation()

  return (
    <Title {...restProps} variant="h1">
      {back && <Button path="/login" />}
      {t("pages.sessions.title")}
    </Title>
  )
}

export default TitleComponent

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.375rem",
  fontWeight: "700",
  margin: "43px 0",
  position: "relative",
  textAlign: "center",
  width: "100%",
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.125rem",
  },
}))

const Button = styled(Back)`
  position: absolute;
  left: 0;
`
